import { render, staticRenderFns } from "./BNPL.vue?vue&type=template&id=5160b5fc"
import script from "./BNPL.vue?vue&type=script&lang=js"
export * from "./BNPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports